import React from "react";

const PasswordLogo: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={50}
    height={51}
    viewBox="0 0 50 51"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.512 34.615c0-1.707.67-3.344 1.863-4.55a6.328 6.328 0 014.5-1.885c1.688 0 3.306.678 4.5 1.884a6.472 6.472 0 011.863 4.55c0 1.707-.67 3.344-1.863 4.55a6.328 6.328 0 01-4.5 1.885 6.328 6.328 0 01-4.5-1.884 6.472 6.472 0 01-1.863-4.55zm6.363-2.925c-.767 0-1.503.308-2.045.856a2.942 2.942 0 00-.847 2.069c0 .775.304 1.52.847 2.068a2.877 2.877 0 002.045.856c.767 0 1.503-.308 2.045-.856a2.942 2.942 0 00.847-2.068c0-.776-.304-1.52-.847-2.069a2.877 2.877 0 00-2.045-.856z"
      fill="#8065C9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.256 18.945v-3.049c0-4.189 1.645-8.206 4.575-11.168A15.531 15.531 0 0124.875.102c4.142 0 8.115 1.664 11.044 4.626a15.885 15.885 0 014.575 11.168v3.05a21.93 21.93 0 011.486.149c2.082.28 3.836.89 5.23 2.296 1.392 1.408 1.99 3.182 2.272 5.288.268 2.029.268 4.61.268 7.808v.258c0 3.198 0 5.78-.268 7.808-.283 2.106-.88 3.88-2.273 5.288-1.393 1.409-3.147 2.013-5.23 2.298-2.005.272-4.558.271-7.72.271H15.491c-3.163 0-5.716 0-7.722-.27-2.082-.286-3.836-.89-5.23-2.299C1.149 46.433.55 44.66.27 42.553 0 40.524 0 37.943 0 34.745v-.258c0-3.199 0-5.78.27-7.808.278-2.106.88-3.88 2.27-5.288 1.394-1.41 3.148-2.013 5.23-2.296.494-.067.99-.117 1.486-.15zm3.47-3.049c0-3.258 1.28-6.383 3.559-8.686a12.08 12.08 0 018.59-3.599 12.08 12.08 0 018.59 3.599 12.355 12.355 0 013.558 8.686v2.932c-.863-.007-1.786-.007-2.765-.007H15.492c-.979 0-1.9 0-2.765.007v-2.932zm-4.493 6.676c-1.698.232-2.596.655-3.237 1.301-.641.648-1.058 1.556-1.287 3.276-.233 1.767-.238 4.109-.238 7.467 0 3.358.005 5.7.238 7.469.23 1.718.648 2.625 1.287 3.274.64.648 1.539 1.069 3.24 1.3 1.744.237 4.063.242 7.383.242h18.512c3.32 0 5.637-.005 7.386-.241 1.698-.232 2.596-.656 3.237-1.301.641-.649 1.058-1.556 1.287-3.276.233-1.767.238-4.11.238-7.467 0-3.358-.005-5.703-.238-7.47-.23-1.717-.648-2.625-1.287-3.273-.64-.648-1.539-1.07-3.24-1.3-1.746-.237-4.063-.242-7.383-.242H15.619c-3.32 0-5.639.005-7.386.241z"
      fill="#8065C9"
    />
  </svg>
);

export default PasswordLogo;
